// 최근 선택한 주소 — 이 브라우저에만 남는다(localStorage). 회원 여부와 무관.

const KEY = 'qw_recent_addresses';
const MAX = 6;

function save(list) {
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch (e) {
    // 저장 공간이 막힌 브라우저(시크릿 모드 등)는 조용히 건너뛴다
  }
}

export function loadRecent() {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(list) ? list.filter((i) => i && i.id) : [];
  } catch (e) {
    return [];
  }
}

export function pushRecent(item) {
  const list = [{ ...item, at: Date.now() }, ...loadRecent().filter((i) => i.id !== item.id)].slice(0, MAX);
  save(list);
  return list;
}

export function removeRecent(id) {
  const list = loadRecent().filter((i) => i.id !== id);
  save(list);
  return list;
}

export function clearRecent() {
  save([]);
  return [];
}
